module.exports = __webpack_public_path__ + "139af9a045d360a5a88a50f48460fa9e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/prologis_2023_chart.png
// module id = 1725
// module chunks = 0